import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Tooltip, Icon, tokens } from '@hotjar/hotsauce';

export const AddressBarIcon = ({ icon, tooltip, className, 'data-testid': dataTestid }) => {
  return (
    <div
      css={css`
        cursor: pointer;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      `}
      className={className}
      data-testid={dataTestid}
    >
      <Tooltip text={tooltip} placement="bottom">
        <span>
          <Icon
            icon={icon}
            size="m"
            css={css`
              color: ${tokens.BRAND_COLORS.midnight_600};
            `}
          />
        </span>
      </Tooltip>
    </div>
  );
};

AddressBarIcon.defaultProps = {
  className: '',
  'data-testid': '',
};

AddressBarIcon.propTypes = {
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  icon: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};
